import createTypography from '@mui/material/styles/createTypography';
import breakpoints from '../breakpoints';
import palette from '../palette';
const typography = createTypography(palette, {
    fontFamily: 'Maax',
    h1: {
        fontSize: '56px',
        lineHeight: '64px',
        letterSpacing: '-0.24px',
        [breakpoints.only('mobile')]: {
            fontSize: '40px',
            lineHeight: '58px',
        },
    },
    h2: {
        fontSize: '48px',
        lineHeight: '56px',
        letterSpacing: '-0.2px',
        [breakpoints.only('mobile')]: {
            fontSize: '32px',
            lineHeight: '40px',
        },
    },
    h3: {
        fontSize: '32px',
        lineHeight: '40px',
        letterSpacing: '-0.2px',
        [breakpoints.only('mobile')]: {
            fontSize: '24px',
            lineHeight: '32px',
        },
    },
    subtitle1: {
        fontFamily: 'Maax',
        fontWeight: 500,
        fontStyle: 'italic',
        fontSize: '32px',
        lineHeight: '36px',
        letterSpacing: '-0.1px',
        [breakpoints.only('mobile')]: {
            fontSize: '24px',
            lineHeight: '28px',
        },
    },
    subtitle2: {
        fontFamily: 'Maax',
        fontWeight: 500,
        fontStyle: 'italic',
        fontSize: '24px',
        lineHeight: '28px',
        letterSpacing: '-0.1px',
        [breakpoints.only('mobile')]: {
            fontSize: '20px',
            lineHeight: '24px',
        },
    },
    body1: {
        fontFamily: 'Maax',
        fontSize: '20px',
        lineHeight: '24px',
        letterSpacing: '-0.1px',
        [breakpoints.only('mobile')]: {
            fontSize: '16px',
            lineHeight: '24px',
        },
    },
    body2: {
        fontFamily: 'Maax',
        fontSize: '16px',
        lineHeight: '24px',
        letterSpacing: '-0.1px',
        [breakpoints.only('mobile')]: {
            fontSize: '14px',
            lineHeight: '20px',
        },
    },
    overline: {
        fontFamily: 'GT-Pressura',
        textTransform: 'uppercase',
        fontSize: '14px',
        lineHeight: '16px',
        letterSpacing: '0.5px',
    },
    cta: {
        fontFamily: 'Maax',
        fontWeight: 500,
        fontSize: '16px',
        lineHeight: '24px',
        letterSpacing: '-0.1px',
        [breakpoints.only('mobile')]: {
            fontSize: '14px',
            lineHeight: '20px',
        },
    },
    link: {
        fontFamily: 'Maax',
        textDecorationLine: 'underline',
        fontSize: '16px',
        lineHeight: '24px',
        letterSpacing: '-0.1px',
        [breakpoints.only('mobile')]: {
            fontSize: '14px',
            lineHeight: '20px',
        },
    },
    button: {
        fontFamily: 'Maax',
        fontSize: '16px',
        lineHeight: '24px',
        letterSpacing: '-0.1px',
        fontWeight: 400,
        textTransform: 'unset',
        [breakpoints.only('mobile')]: {
            fontSize: '14px',
            lineHeight: '20px',
        },
    },
    caption: {
        fontFamily: 'Maax',
        fontSize: '12px',
        lineHeight: '16px',
        letterSpacing: '-0.1px',
        fontWeight: 400,
        [breakpoints.only('mobile')]: {
            fontSize: '10px',
            lineHeight: '16px',
        },
    },
});
export default typography;
//# sourceMappingURL=typography.js.map